import axios from 'axios';
import axiosRetry from 'axios-retry';
import { Store } from '@reduxjs/toolkit';
import { AppState } from 'app/store';
import {
  axios401ResponseInterceptor,
  AXIOS_RETRY_CONFIG,
  axiosAuthHeaderRequestInterceptor,
} from './utils';

axiosRetry(axios, AXIOS_RETRY_CONFIG);

export const createAxiosInterceptor = (store: Store<AppState>) => {
  axios.interceptors.request.use(axiosAuthHeaderRequestInterceptor(store));
  axios.interceptors.response.use(...axios401ResponseInterceptor(store));
};
